<template>
  <div class="hello">
    <!-- ==================== 顶部导航栏 ==================== -->
    <div class="nav">
      <!-- 左侧 Logo 区域 -->
      <div class="nav__left">
        <a href="#" class="nav__logo-link">
          <img src="../assets/logo.png" alt="">
        </a>
      </div>

      <!-- 中间菜单区域 -->
      <div class="nav__center">
        <ul class="nav__menu">
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'home' }"
          >
            <router-link to="/" @click.native="handleMenuClick('home')">首页</router-link>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'channels' }"
            @click="toggleChannels"
          >
            <a href="#">分类 <span class="nav__menu-arrow" :class="{ 'nav__menu-arrow--up': isChannelsOpen }">▾</span></a>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'apps' }"
          >
            <router-link to="/mv" @click.native="handleMenuClick('apps')">MV</router-link>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'upload' }"
            @click="handleUploadClick"
          >
            <a href="#">上传音乐</a>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'qsn' }"
            @click="handleQsnClick"
          >
            <router-link to="/qsn" @click.native="handleMenuClick('qsn')">青少年模式</router-link>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'smrz' }"
            @click="handleSmrzClick"
          >
            <router-link to="/smrz" @click.native="handleMenuClick('smrz')">实名认证</router-link>
          </li>
          <li
            class="nav__menu-item"
            :class="{ 'nav__menu-item--active': activeMenu === 'search' }"
            @click="handleSearchClick"
          >
            <router-link to="/sousuo" @click.native="handleMenuClick('search')">搜索</router-link>
          </li>
        </ul>
      </div>

      <!-- 右侧按钮区域 -->
      <div class="nav__right">
        <router-link to="/vip" class="nav__btn nav__btn--trial">开启会员</router-link>
        <div class="nav__user-menu" v-if="isLoggedIn">
          <router-link to="/geren" class="nav__btn nav__btn--login" @mouseenter.native="showLogout = true" @mouseleave.native="showLogout = false">{{this.$store.state.userInfo.nicheng}}</router-link>
          <button class="nav__btn nav__btn--logout" v-show="showLogout" @click="logout" @mouseenter="showLogout = true" @mouseleave="showLogout = false">退出</button>
        </div>
        <a href="#" class="nav__btn nav__btn--login" @click.prevent="showLoginModal" v-if="!isLoggedIn">登录</a>
        <a href="#" class="nav__btn nav__btn--signup" @click.prevent="showSignupModal" v-if="!isLoggedIn">注册</a>
      </div>
    </div>

    <!-- ==================== CHANNELS 下拉菜单 ==================== -->
    <div class="channels-dropdown" :class="{ 'channels-dropdown--open': isChannelsOpen }">
      <div class="channels-dropdown__inner">
        <button class="channels-dropdown__close" @click="closeChannels">✕</button>
        <!-- 分类标签 -->
        <div class="channels-dropdown__tabs">
          <button
            v-for="tab in categoryTabs"
            :key="tab"
            class="channels-dropdown__tab"
            :class="{ 'channels-dropdown__tab--active': activeCategory === tab }"
            @click="loadChannelsByCategory(tab)"
          >
            {{ tab }}
          </button>
        </div>
        <!-- 频道列表 -->
        <div class="channels-dropdown__grid">
          <div v-for="channel in channels" :key="channel.id" class="channels-dropdown__item" @click="goToSongDetail(channel.id)">
            <div class="channels-dropdown__item-img-wrap">
              <img :src="channel.image" :alt="channel.music_name" class="channels-dropdown__item-img" />
              <div v-if="channel.isnomf == 1" class="channels-dropdown__item-vip">VIP</div>
              <div class="channels-dropdown__item-play">
                <span class="channels-dropdown__item-play-icon">▶</span>
              </div>
            </div>
            <span class="channels-dropdown__item-name">{{ channel.music_name }}</span>
            <span class="channels-dropdown__item-singer">{{ channel.singer }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 内容区域 ==================== -->
    <div class="content" :class="{ 'content--shifted': isChannelsOpen }">
      <router-view></router-view>
    </div>

    <!-- ==================== 登录/注册弹窗 ==================== -->
    <div class="auth-modal" v-if="isAuthModalVisible" @click.self="closeAuthModal">
      <div class="auth-modal__inner">
        <button class="auth-modal__close" @click="closeAuthModal">
          <svg class="auth-modal__close-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <!-- 登录弹窗 -->
        <div class="auth-modal__content" v-if="authMode === 'login'">
          <div class="auth-modal__logo">
            <img src="../assets/logo.png" alt="Logo" class="auth-modal__logo-img" />
          </div>
          <h2 class="auth-modal__title">登录</h2>
          <p class="auth-modal__subtitle">欢迎回来，继续您的音乐之旅</p>

          <form class="auth-modal__form" @submit.prevent="handleLogin" autocomplete="off">
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="text" class="auth-modal__input" placeholder="账号" v-model="loginForm.username" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
            </div>
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="password" class="auth-modal__input" placeholder="密码" v-model="loginForm.password" autocomplete="new-password" />
            </div>
            <div class="auth-modal__form-group auth-modal__form-group--checkbox">
              <label class="auth-modal__checkbox-label">
                <input type="checkbox" v-model="loginForm.keepLoggedIn" />
                <span class="auth-modal__checkbox-custom"></span>
                保持登录状态
              </label>
            </div>
            <button type="submit" class="auth-modal__submit-btn">登录</button>
          </form>

          <div class="auth-modal__footer">
            <p class="auth-modal__footer-text">
              还没有账号？
              <a href="#" class="auth-modal__footer-link" @click.prevent="switchToSignup">立即注册</a>
            </p>
          </div>
        </div>

        <!-- 注册弹窗 -->
        <div class="auth-modal__content" v-else>
          <div class="auth-modal__logo">
            <img src="../assets/logo.png" alt="Logo" class="auth-modal__logo-img" />
          </div>
          <h2 class="auth-modal__title">注册</h2>
          <p class="auth-modal__subtitle">创建账号，开启您的音乐之旅</p>


          <form class="auth-modal__form" @submit.prevent="handleSignup" autocomplete="off">
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="text" class="auth-modal__input" placeholder="账号" v-model="signupForm.username" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
            </div>
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="email" class="auth-modal__input" placeholder="邮箱" v-model="signupForm.email" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
            </div>
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="password" class="auth-modal__input" placeholder="密码（必须包含字母和数字）" v-model="signupForm.password" autocomplete="new-password" />
            </div>
            <div class="auth-modal__form-group">
              <span class="auth-modal__required">*</span>
              <input type="password" class="auth-modal__input" placeholder="确认密码" v-model="signupForm.confirmPassword" autocomplete="new-password" />
            </div>
            <div class="auth-modal__form-group auth-modal__form-group--checkbox">
              <label class="auth-modal__checkbox-label">
                <input type="checkbox" v-model="signupForm.agree" />
                <span class="auth-modal__checkbox-custom"></span>
                我已阅读并同意<router-link to="/yhys?tab=agreement" class="auth-modal__link" @click.native="closeAuthModal">《用户协议》</router-link>和<router-link to="/yhys?tab=privacy" class="auth-modal__link" @click.native="closeAuthModal">《隐私政策》</router-link>
              </label>
            </div>
            <button type="submit" class="auth-modal__submit-btn">创建账号</button>
          </form>

          <div class="auth-modal__footer">
            <p class="auth-modal__footer-text">
              已有账号？
              <a href="#" class="auth-modal__footer-link" @click.prevent="switchToLogin">立即登录</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== VIP提示弹窗 ==================== -->
    <div class="vip-modal" v-if="isVipModalVisible" @click.self="closeVipModal">
      <div class="vip-modal__inner">
        <div class="vip-modal__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="#f37021" stroke-width="2">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"></path>
          </svg>
        </div>
        <h3 class="vip-modal__title">VIP专属内容</h3>
        <p class="vip-modal__desc">该歌曲为VIP歌曲，请开通VIP后畅听完整内容</p>
        <div class="vip-modal__btn-group">
          <button class="vip-modal__btn vip-modal__btn--cancel" @click="closeVipModal">关闭</button>
          <button class="vip-modal__btn vip-modal__btn--vip" @click="goToVip">开通VIP</button>
        </div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="site-footer">
      <div class="site-footer__top">
        <div class="site-footer__top-inner">
          <div class="site-footer__top-logos">
            <span class="site-footer__logo">聆听原创，听见独特心声</span>
            <span class="site-footer__logo">以原创为声，赴一场乐相逢</span>
            <span class="site-footer__logo">好曲皆原创，每首皆风景</span>
          </div>
        </div>
      </div>
      <div class="site-footer__bottom">
        <div class="site-footer__bottom-inner">
          <div class="site-footer__bottom-left">
            <div class="site-footer__links">
              <router-link to="/">首页</router-link>
              <router-link to="/mv">MV</router-link>
              <router-link to="/vip">会员</router-link>
              <router-link to="/yhys?tab=privacy">隐私政策</router-link>
              <router-link to="/yhys?tab=agreement">用户协议</router-link>
              <a href="https://www.12377.cn/" target="_blank">举报中心</a>
            </div>
          </div>
          <div class="site-footer__bottom-right">
            <div class="site-footer__info">
              <p class="site-footer__company">北京一击企服科技有限公司</p>
              <p class="site-footer__contact">
                <span>联系电话：18519373645</span>
              </p>
              <p class="site-footer__address">公司地址：北京市朝阳区西大望路1号1号楼9层1001</p>
              <p class="site-footer__icp">京ICP备2024102164号-1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ==================== 底部播放器 ==================== -->
    <audio ref="audioPlayer" :src="songInfo.music_url || ''" @timeupdate="updateProgress" @ended="onAudioEnded" hidden></audio>
    <div class="player" :class="{ 'player--expanded': isPlayerExpanded, 'player--hidden': isPlayerHidden || !isPlayerVisible }">
      <!-- 展开的歌词面板 -->
      <div class="player__panel">
        <div class="player__panel-inner">
          <div class="player__panel-header">
            <div class="player__panel-song-name">{{ songInfo.music_name }}</div>
            <div class="player__panel-song-singer">{{ songInfo.singer }}</div>
          </div>
          <div class="player__lyrics-list">
            <div v-for="(line, index) in lyrics" :key="index" class="player__lyrics-line">
              {{ line.text }}
            </div>
            <div v-if="lyrics.length === 0" class="player__lyrics-empty">
              暂无歌词
            </div>
          </div>
        </div>
      </div>

      <!-- 播放器主体 -->
      <div class="player__body">
        <!-- 左侧：展开按钮 + 频道封面 + 频道信息 + 收藏 + 跳过 -->
        <div class="player__left">
          <button class="player__toggle" @click="isPlayerExpanded = !isPlayerExpanded" title="展开频道列表">
            <svg v-if="!isPlayerExpanded" class="player__toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="18 15 12 9 6 15"></polyline>
            </svg>
            <svg v-else class="player__toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          <div class="player__channel-cover">
            <img
              :src="songInfo.image || 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=mellow%20jazz%20radio%20station%20cover%20warm%20cozy%20vintage&image_size=square'"
              :alt="songInfo.music_name || 'Mellow Jazz'"
            />
          </div>

          <div class="player__channel-info">
            <div class="player__channel-label">{{ songInfo.fenlei_name || '电台' }}</div>
            <div class="player__channel-name">{{ songInfo.music_name || '柔和爵士' }}</div>
          </div>

          <button class="player__icon-btn player__icon-btn--favorite" :class="{ 'player__icon-btn--favorited': songInfo.status == 1 }" @click="toggleFavorite" title="收藏频道">
            <svg class="player__icon player__icon--heart" viewBox="0 0 24 24" :fill="songInfo.status == 1 ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </button>

          <button class="player__icon-btn" @click="playNext" title="下一首">
            <svg class="player__icon player__icon--skip" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5 4 15 12 5 20 5 4"></polygon>
              <rect x="19" y="4" width="2" height="16"></rect>
            </svg>
          </button>
        </div>

        <!-- 中间：播放按钮 + 歌曲信息 + 进度条 -->
        <div class="player__center">
          <button class="player__play-btn" @click="togglePlay" title="播放/暂停">
            <svg v-if="!isPlaying" class="player__play-icon" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="6 4 20 12 6 20 6 4"></polygon>
            </svg>
            <svg v-else class="player__play-icon" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="4" width="4" height="16"></rect>
              <rect x="14" y="4" width="4" height="16"></rect>
            </svg>
          </button>

          <div class="player__track">
            <div class="player__track-title">{{ songInfo.singer || '汤姆·麦科米克' }} - {{ songInfo.music_name || '我愚蠢的心' }}</div>
            <div class="player__track-progress">
              <div class="player__progress-bar" 
                   @click="seekTo"
                   @mousedown="startDragProgress"
                   @touchstart="startDragProgress">
                <!-- VIP歌曲30秒限制节点 -->
                <div v-if="songInfo.isnomf == 1 && !hasVipAccess()" 
                     class="player__progress-vip-marker" 
                     :style="{ left: (30 / durationSeconds) * 100 + '%' }"></div>
                <div class="player__progress-filled" :style="{ width: progressPercent + '%' }"></div>
                <div class="player__progress-thumb" :style="{ left: progressPercent + '%' }"></div>
              </div>
              <span class="player__time">{{ formatTime(currentTime) }} / {{ songInfo.shichang || '4:52' }}</span>
            </div>
          </div>
        </div>

        <!-- 右侧：音量 + 分享 + 设置 + 列表 -->
        <div class="player__right">
          <button class="player__icon-btn" title="音量">
            <svg class="player__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
            </svg>
          </button>
          <div class="player__volume-bar" 
               @click="setVolume"
               @mousedown="startDragVolume"
               @touchstart="startDragVolume">
            <div class="player__volume-filled" :style="{ width: volumePercent + '%' }"></div>
            <div class="player__volume-thumb" :style="{ left: volumePercent + '%' }"></div>
          </div>
          <button class="player__icon-btn" title="隐藏播放器" @click="isPlayerHidden = true">
            <svg class="player__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../store/store'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      activeMenu: 'home',
      isChannelsOpen: false,
      isPlayerExpanded: false,
      progressPercent: 98.5,
      currentTime: 290,
      isPlayerHidden: false,
      volumePercent: 65,
      isDraggingProgress: false,
      isDraggingVolume: false,
      isSeeking: false,
      lyrics: [],
      isAuthModalVisible: false,
      showLogout: false,
      hasShownVipModal: false,
      isVipModalVisible: false,
      authMode: 'login',
      loginForm: {
        username: '',
        password: '',
        keepLoggedIn: false
      },
      signupForm: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        agree: false
      },
      activeCategory: '全部',
      categoryTabs: [
        '全部', '舒缓慢板', '治愈暖心', '轻快甜系', '伤感慢歌',
        '空灵氛围感', '活力轻快', '慵懒松弛', '安眠助眠', '温柔抒情',
        '辽阔治愈'
      ],
      channels: []
    }
  },
  computed: {
    currentLyric() {
      let lyric = '';
      for (let i = this.lyrics.length - 1; i >= 0; i--) {
        if (this.currentTime >= this.lyrics[i].time) {
          lyric = this.lyrics[i].text;
          break;
        }
      }
      return lyric;
    },
    songInfo() {
      return store.state.SongInfo || {};
    },
    // 从Vuex获取登录状态
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    // 歌曲时长（秒）
    durationSeconds() {
      const shichang = this.songInfo.shichang || '4:52';
      const [mins, secs] = shichang.split(':').map(Number);
      return mins * 60 + secs || 292; // 默认4分52秒
    },
    isPlayerVisible() {
      return store.state.BottomPlay;
    },
    isPlaying() {
      return store.state.isPlaying;
    }
  },
  mounted() {
    const savedUser = localStorage.getItem('YousrDL');
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      store.commit('setUserInfo', userData);
    }

    this.loadChannelsByCategory('全部');

    this.lyricTimer = setInterval(() => {
      if (this.isPlaying && !this.isDraggingProgress && !this.isSeeking) {
        const audio = this.$refs.audioPlayer;
        if (audio && audio.duration) {
          this.currentTime = Math.floor(audio.currentTime);
          this.progressPercent = (this.currentTime / audio.duration) * 100;
        }
      }
    }, 1000);

    this.$router.afterEach((to) => {
      if (to.path === '/mv' || to.path === '/mvxq') {
        this.$store.commit('setPlaying', false);
        this.isPlayerHidden = true;
      } else {
        this.isPlayerHidden = false;
      }
    });

    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy() {
    if (this.lyricTimer) {
      clearInterval(this.lyricTimer);
    }
    document.removeEventListener('click', this.handleGlobalClick);
  },
  watch: {
    songInfo: {
      handler(newInfo) {
        if (newInfo && newInfo.id) {
          this.$store.commit('setPlaying', true);
          this.currentTime = 0;
          this.progressPercent = 0;
          this.hasShownVipModal = false;
          this.parseLyrics(newInfo.music_lrc || '');
          console.log('解析后的歌词:', this.lyrics);
          setTimeout(() => {
            const audio = this.$refs.audioPlayer;
            if (audio) {
              audio.play().catch(e => {
                console.error('自动播放失败:', e);
              });
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  methods: {
    handleMenuClick(menu) {
      this.activeMenu = menu;
      this.isChannelsOpen = false;
    },
    goToSongDetail(songId) {
      this.isChannelsOpen = false;
      this.$router.push(`/xiangqing/${songId}`);
    },
    /**
     * 格式化时间显示
     * @param {number} seconds - 秒数
     * @returns {string} 格式化后的时间字符串 (mm:ss)
     */
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    
    /**
     * 解析歌词字符串
     * @param {string} lrcText - 歌词文本
     */
    parseLyrics(lrcText) {
      if (!lrcText) {
        this.lyrics = [];
        return;
      }
      
      const lines = lrcText.split('\n');
      const result = [];
      const timeRegex = /\[(\d{2}):(\d{2})\.(\d{2,3})\]/;
      let hasTimeTags = false;
      
      lines.forEach(line => {
        const trimmedLine = line.trim();
        if (!trimmedLine) return;
        
        const match = trimmedLine.match(timeRegex);
        if (match) {
          hasTimeTags = true;
          const mins = parseInt(match[1]);
          const secs = parseInt(match[2]);
          const ms = parseInt(match[3]);
          const time = mins * 60 + secs + ms / 100;
          const text = trimmedLine.replace(timeRegex, '').trim();
          if (text) {
            result.push({ time, text });
          }
        }
      });
      
      if (hasTimeTags) {
        result.sort((a, b) => a.time - b.time);
        this.lyrics = result;
      } else {
        lines.forEach((line, index) => {
          const trimmedLine = line.trim();
          if (trimmedLine) {
            result.push({ time: index * 3, text: trimmedLine });
          }
        });
        this.lyrics = result;
      }
    },
    
    /**
     * 播放/暂停切换
     */
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      if (this.isPlaying) {
        audio.pause();
        this.$store.commit('setPlaying', false);
      } else {
        audio.play().catch(e => {
          console.error('播放失败:', e);
        });
        this.$store.commit('setPlaying', true);
      }
    },
    
    /**
     * 播放下一首
     */
    playNext() {
      const currentId = this.$store.state.SongId;
      const nextId = currentId + 1;
      
      if (nextId >= 105) {
        alert('这已经是最后一首歌曲了');
        return;
      }
      
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/yydetail', {
        params: { id: nextId }
      })
      .then(response => {
        console.log(response.data.data.detail);
        const songData = response.data.data.detail;
        if (!songData || !songData.id) {
          alert('获取下一首歌曲失败');
          return;
        }
        
        this.$store.commit('setSongInfo', songData);
        this.$store.commit('setSongId', songData.id);
        this.$store.commit('PlayerStatus', true);
        this.$store.commit('setPlaying', true);
        
        const audio = this.$refs.audioPlayer;
        if (audio) {
          audio.play().catch(() => {});
        }
      })
      .catch(error => {
        console.error('获取下一首歌曲失败:', error);
        alert('获取下一首歌曲失败，请稍后重试');
      });
    },
    
    /**
     * 退出登录
     */
    logout() {
      localStorage.removeItem('YousrDL');
      this.showLogout = false;
      this.$store.commit('setUserInfo', [{id:0,image:'../assets/img-today-0364456e.png',username:'无'}]);
      alert('退出登录成功');
      this.$router.push('/');
    },
    
    /**
     * 切换收藏状态
     */
    toggleFavorite() {
      if (!this.isLoggedIn) {
        alert('你还没有登录！');
        return;
      }
      
      const songId = this.$store.state.SongId;
      if (songId <= 0) {
        alert('请先播放一首歌曲');
        return;
      }
      
      const savedUser = localStorage.getItem('YousrDL');
     
      if (!savedUser) {
        alert('你还没有登录！');
        return;
      }
      
      const userInfo = JSON.parse(savedUser);
       console.log(userInfo);
      const username = userInfo.username || '';
      
      if (!username) {
        alert('获取用户信息失败');
        return;
      }
      
      const currentStatus = this.songInfo.status == 1 ? 0 : 1;
      
      axios.post('https://xinyinyue.xiangyouhulian.cn/api/index/shoucang', {
        username: username,
        gequid: songId,
        status: currentStatus
      })
      .then(response => {
        if (response.data.code === 1) {
          const newSongInfo = { ...this.songInfo };
          newSongInfo.status = currentStatus;
          this.$store.commit('setSongInfo', newSongInfo);
          alert(currentStatus === 1 ? '收藏成功' : '取消收藏成功');
        } else {
          alert(response.data.msg || '操作失败');
        }
      })
      .catch(error => {
        console.error('收藏失败:', error);
        alert('收藏失败，请稍后重试');
      });
    },
    
    /**
     * 更新播放进度（监听audio的timeupdate事件）
     */
    updateProgress() {
      if (this.isDraggingProgress) return;
      if (this.isSeeking) return;
      
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      this.currentTime = Math.floor(audio.currentTime);
      const duration = audio.duration || 292;
      this.progressPercent = (this.currentTime / duration) * 100;

      this.checkVipLimit(audio);
    },

    checkVipLimit(audio) {
      if (!audio || !this.songInfo.isnomf || this.songInfo.isnomf != 1) return;

      if (this.hasVipAccess()) return;

      if (audio.currentTime >= 30) {
        audio.pause();
        if (!this.hasShownVipModal) {
          this.hasShownVipModal = true;
          this.isVipModalVisible = true;
        }
      }
    },

    closeVipModal() {
      this.isVipModalVisible = false;
    },

    goToVip() {
      this.isVipModalVisible = false;
      this.$router.push('/vip');
    },

    hasVipAccess() {
      const savedUser = localStorage.getItem('YousrDL');
      if (!savedUser) return false;

      const userInfo = JSON.parse(savedUser);
      if (!userInfo) return false;

      // 处理数组格式
      if (Array.isArray(userInfo) && userInfo.length > 0) {
        return userInfo[0].isnovip == 1;
      }
      // 处理对象格式
      if (userInfo.isnovip !== undefined) {
        return userInfo.isnovip == 1;
      }
      return false;
    },
    
    /**
     * 歌曲播放结束处理
     */
    onAudioEnded() {
      this.$store.commit('setPlaying', false);
          this.currentTime = 0;
      this.progressPercent = 0;
    },
    /**
     * 进度条点击跳转
     * @param {Event} e - 点击事件
     */
    seekTo(e) {
      if (this.isDraggingProgress) return;
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      const rect = e.currentTarget.getBoundingClientRect();
      const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
      
      this.isSeeking = true;
      this.progressPercent = percent;
      
      if (audio.duration) {
        let targetTime = (percent / 100) * audio.duration;
        
        if (this.songInfo.isnomf == 1 && !this.hasVipAccess() && targetTime > 30) {
          targetTime = 30;
        }
        
        audio.currentTime = targetTime;
        this.currentTime = Math.floor(targetTime);
      }
      
      setTimeout(() => {
        this.isSeeking = false;
      }, 500);
    },
    
    /**
     * 开始拖拽进度条
     * @param {Event} e - 鼠标按下/触摸开始事件
     */
    startDragProgress(e) {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      const doDrag = (ev) => {
        const rect = document.querySelector('.player__progress-bar').getBoundingClientRect();
        const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX;
        const percent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        this.progressPercent = percent;
        
        if (audio.duration) {
          const targetTime = (percent / 100) * audio.duration;
          audio.currentTime = targetTime;
          this.currentTime = Math.floor(targetTime);
        }
      };
      
      const stopDrag = () => {
        this.isDraggingProgress = false;
        document.removeEventListener('mousemove', doDrag);
        document.removeEventListener('mouseup', stopDrag);
        document.removeEventListener('touchmove', doDrag);
        document.removeEventListener('touchend', stopDrag);
        
        this.isSeeking = true;
        setTimeout(() => {
          this.isSeeking = false;
        }, 500);
      };
      
      this.isDraggingProgress = true;
      document.addEventListener('mousemove', doDrag);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('touchmove', doDrag, { passive: false });
      document.addEventListener('touchend', stopDrag);
      
      doDrag(e);
    },
    
    /**
     * 设置播放进度
     * @param {number} percent - 进度百分比 (0-100)
     */
    setProgress(percent) {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      this.progressPercent = percent;
      if (audio.duration) {
        this.currentTime = Math.floor((percent / 100) * audio.duration);
        audio.currentTime = this.currentTime;
      }
    },
    
    /**
     * 音量条点击设置音量
     * @param {Event} e - 点击事件
     */
    setVolume(e) {
      if (this.isDraggingVolume) return;
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      const rect = e.currentTarget.getBoundingClientRect();
      const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
      this.setVolumePercent(percent);
    },
    
    /**
     * 开始拖拽音量条
     * @param {Event} e - 鼠标按下/触摸开始事件
     */
    startDragVolume(e) {
      this.isDraggingVolume = true;
      const audio = this.$refs.audioPlayer;
      
      const moveHandler = (ev) => {
        if (!this.isDraggingVolume) return;
        
        const rect = document.querySelector('.player__volume-bar').getBoundingClientRect();
        const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX;
        const percent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        this.volumePercent = percent;
        if (audio) {
          audio.volume = percent / 100;
        }
      };
      
      const upHandler = () => {
        this.isDraggingVolume = false;
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', upHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', upHandler);
      };
      
      document.addEventListener('mousemove', moveHandler);
      document.addEventListener('mouseup', upHandler);
      document.addEventListener('touchmove', moveHandler, { passive: false });
      document.addEventListener('touchend', upHandler);
      
      moveHandler(e);
    },
    
    /**
     * 设置音量百分比
     * @param {number} percent - 音量百分比 (0-100)
     */
    setVolumePercent(percent) {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      
      this.volumePercent = percent;
      audio.volume = percent / 100;
    },
    toggleChannels() {
      this.activeMenu = 'channels';
      this.isChannelsOpen = !this.isChannelsOpen;
    },
    closeChannels() {
      this.isChannelsOpen = false;
    },
    loadChannelsByCategory(name) {
      this.activeCategory = name;
      const params = name === '全部' ? {} : { name };
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/index', { params })
        .then(response => {
          const data = response.data;
          if (data.data) {
            this.channels = data.data;
          } else {
            this.channels = data;
          }
        })
        .catch(error => {
          console.error('获取频道数据失败:', error);
        });
    },
    handleGlobalClick(e) {
      const target = e.target;
      const isChannelMenu = target.closest('.channels-dropdown') || target.closest('.nav__btn--channels') || target.closest('.nav__menu-item');
      const isPlayerPanel = target.closest('.player__panel') || target.closest('.player__toggle');
      
      if (!isChannelMenu && this.isChannelsOpen) {
        this.isChannelsOpen = false;
      }
      
      if (!isPlayerPanel && this.isPlayerExpanded) {
        this.isPlayerExpanded = false;
      }
    },
    showLoginModal() {
      this.authMode = 'login';
      this.isAuthModalVisible = true;
      document.body.style.overflow = 'hidden';
    },
    showSignupModal() {
      this.authMode = 'signup';
      this.isAuthModalVisible = true;
      document.body.style.overflow = 'hidden';
    },
    closeAuthModal() {
      this.isAuthModalVisible = false;
      document.body.style.overflow = '';
    },
    switchToSignup() {
      this.authMode = 'signup';
      this.clearAuthForm('signup')
    },
    switchToLogin() {
      this.authMode = 'login';
      this.clearAuthForm('login')
    },
    clearAuthForm(mode) {
      if (mode === 'login') {
        this.loginForm = {
          username: '',
          password: '',
          keepLoggedIn: false
        }
      } else {
        this.signupForm = {
          username: '',
          email: '',
          password: '',
          confirmPassword: '',
          agree: false
        }
      }
      setTimeout(() => {
        document.querySelectorAll('.auth-modal__input').forEach(el => {
          el.value = ''
        })
      }, 100)
    },
    handleLogin() {
      if (!this.loginForm.username.trim()) {
        alert('请输入账号');
        return;
      }
      if (!this.loginForm.password.trim()) {
        alert('请输入密码');
        return;
      }
      axios.post('https://xinyinyue.xiangyouhulian.cn/api/index/login', {
        username: this.loginForm.username.trim(),
        password: this.loginForm.password.trim()
      })
      .then(response => {
        console.log('登录成功:', response.data);
        const userData = response.data;
        if (userData.code == 1) {
          localStorage.setItem('YousrDL', JSON.stringify(userData.data));
          this.$store.commit('setUserInfo', userData.data);
          console.log(this.$store.state.userInfo);
          alert('登录成功！欢迎回来');
          this.closeAuthModal();
          this.loginForm = {
            username: '',
            password: '',
            keepLoggedIn: false
          };
          this.$router.push('/');
        } else {
          alert(userData.message || '登录失败，请检查账号密码');
        }
      })
      .catch(error => {
        console.error('登录失败:', error);
        let errorMsg = '登录失败，请稍后重试';
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
          } else if (error.response.status === 401) {
            errorMsg = '账号或密码错误';
          } else if (error.response.status === 500) {
            errorMsg = '服务器内部错误，请稍后重试';
          }
        } else if (error.request) {
          errorMsg = '网络请求失败，请检查网络连接';
        }
        alert(errorMsg);
      });
    },
    handleUploadClick() {
      if (!this.isLoggedIn) {
        this.showLoginModal();
        return;
      }
      this.$router.push('/geren?tab=upload');
      this.activeMenu = 'upload';
    },
    handleQsnClick() {
      this.activeMenu = 'qsn';
    },
    handleSmrzClick() {
      this.activeMenu = 'smrz';
    },
    handleSearchClick() {
      this.activeMenu = 'search';
    },
    handleSignup() {
      if (!this.signupForm.username.trim()) {
        alert('请输入账号');
        return;
      }
      if (!this.signupForm.email.trim()) {
        alert('请输入邮箱');
        return;
      }
      if (!this.signupForm.password.trim()) {
        alert('请输入密码');
        return;
      }
      if (!this.signupForm.confirmPassword.trim()) {
        alert('请输入确认密码');
        return;
      }
      if (!this.signupForm.agree) {
        alert('请同意用户协议和隐私政策');
        return;
      }
      if (this.signupForm.username.trim().length < 3 || this.signupForm.username.trim().length > 20) {
        alert('账号长度必须在3-20个字符之间');
        return;
      }
      const usernameReg = /^[a-zA-Z0-9]+$/;
      if (!usernameReg.test(this.signupForm.username.trim())) {
        alert('账号只能包含字母和数字，不能包含中文或特殊字符');
        return;
      }
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailReg.test(this.signupForm.email.trim())) {
        alert('请输入正确的邮箱格式');
        return;
      }
      const passwordReg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/;
      if (!passwordReg.test(this.signupForm.password)) {
        alert('密码必须包含字母和数字，且长度在6-20个字符之间');
        return;
      }
      if (this.signupForm.password !== this.signupForm.confirmPassword) {
        alert('两次输入的密码不一致');
        return;
      }
      axios.post('https://xinyinyue.xiangyouhulian.cn/api/index/register', {
        username: this.signupForm.username.trim(),
        email: this.signupForm.email.trim(),
        password: this.signupForm.password
      })
      .then(response => {
        console.log('注册成功:', response.data);
        const userData = response.data;
        if (userData.code === 1 || userData.success) {
          alert('注册成功！请登录');
          this.signupForm = {
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            agree: false
          };
          this.switchToLogin();
        } else {
          alert(userData.message || '注册失败，请重试');
        }
      })
      .catch(error => {
        console.error('注册失败:', error);
        let errorMsg = '注册失败，请稍后重试';
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
          } else if (error.response.status === 400) {
            errorMsg = '请求参数错误，请检查输入';
          } else if (error.response.status === 500) {
            errorMsg = '服务器内部错误，请稍后重试';
          }
        } else if (error.request) {
          errorMsg = '网络请求失败，请检查网络连接';
        }
        alert(errorMsg);
      });
    }
  }
}
</script>

<style scoped lang="scss">
.hello {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #1a1a1a;
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
}

/* ==================== 顶部导航栏 ==================== */
.nav {
  background-color: #9a1f13;
  height: 74px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1000;

  &__left {
    flex-shrink: 0;
  }

  &__logo-link {
    text-decoration: none;
    display: inline-block;
    
    img {
      height: 50px;
      width: auto;
      object-fit: contain;
      vertical-align: middle;
    }
  }

  &__logo {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0.5px;
  }

  &__logo-jazz {
    color: #f37021;
    font-style: italic;
  }

  &__logo-radio {
    color: #ffffff;
  }

  &__logo-dot {
    color: #ffffff;
    font-size: 14px;
    margin-left: 2px;
  }

  &__center {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  &__menu {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 24px;
  }

  &__menu-item {
    cursor: pointer;

    a {
      color: #ffffff;
      text-decoration: none;
      font-size: 13px;
      font-weight: bold;
      letter-spacing: 0.5px;
      padding: 6px 16px;
      border-radius: 3px;
      border: 1px solid transparent;
      transition: background-color 0.2s, border-color 0.2s;
      display: inline-block;

      &:hover {
        background-color: rgba(255, 255, 255, 0.15);
      }
    }

    &--active a {
      border-color: #ffffff;
    }
  }

  &__menu-arrow {
    font-size: 10px;
    margin-left: 3px;
    display: inline-block;
    transition: transform 0.3s ease;

    &--up {
      transform: rotate(180deg);
    }
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__user-menu {
    position: relative;
    z-index: 10;
  }

  &__btn {
    text-decoration: none;
    font-size: 12px;
    font-weight: bold;
    padding: 7px 14px;
    border-radius: 3px;
    transition: background-color 0.2s, color 0.2s;

    &--trial {
      background-color: #f37021;
      color: #ffffff;

      &:hover {
        background-color: #d95e12;
      }
    }

    &--login {
      color: #ffffff;
      border: 1px solid rgba(255, 255, 255, 0.5);

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    &--signup {
      color: #ffffff;
      border: 1px solid #ffffff;

      &:hover {
        background-color: rgba(255, 255, 255, 0.15);
      }
    }

    &--logout {
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 6px;
      color: #ffffff;
      border: 1px solid rgba(255, 255, 255, 0.5);
      background: none;
      cursor: pointer;
      animation: slideDown 0.2s ease-out;
      white-space: nowrap;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==================== CHANNELS 下拉菜单 ==================== */
.channels-dropdown {
  position: absolute;
  top: 74px;
  left: 0;
  right: 0;
  background-color: #5c3538;
  z-index: 999;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  &--open {
    max-height: calc(100vh - 74px - 90px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      background-color: #4a2a2d;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #7a4a4e;
      border-radius: 6px;
      border: 2px solid #4a2a2d;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #8b5a5e;
    }
  }

  &__inner {
    padding: 15px 40px 25px;
    position: relative;
  }

  &__tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    position: relative;
  }

  &__tab {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.75);
    font-size: 13px;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }

    &--active {
      color: #5c3538;
      background-color: #ffffff;

      &:hover {
        color: #5c3538;
        background-color: #ffffff;
      }
    }
  }

  &__close {
    position: absolute;
    top: 15px;
    right: 40px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;
    line-height: 1;
    z-index: 1;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 4px 16px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 6px;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.12);

      .channels-dropdown__item-name {
        color: #ffffff;
      }

      .channels-dropdown__item-play {
        opacity: 1;
      }
    }

    .channels-dropdown__item-name,
    .channels-dropdown__item-singer {
      display: block;
    }
  }

  &__item-img-wrap {
    position: relative;
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    border-radius: 2px;
    overflow: hidden;
  }

  &__item-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    background-color: #8b5a5e;
  }

  &__item-play {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &__item-play-icon {
    color: #ffffff;
    font-size: 14px;
    margin-left: 2px;
  }

  &__item-name {
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    font-weight: 500;
    transition: color 0.2s;
    line-height: 1.2;
  }

  &__item-singer {
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    line-height: 1.2;
  }

  &__item-vip {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #f37021;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    z-index: 3;
  }
}

/* ==================== 内容区域 ==================== */
.content {
  flex: 1;
  width: 100%;
  transition: margin-top 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &--shifted {
    margin-top: 0;
  }
}

/* ==================== 底部播放器 ==================== */
.player {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #8a1a12;
  color: #ffffff;
  z-index: 1001;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  &--hidden {
    transform: translateY(100%);
  }

  &__panel {
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    background-color: #7a1710;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s ease-in-out;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #6b150d;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #a02a1f;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #b03024;
    }
  }

  &--expanded &__panel {
    max-height: 50vh;
    height: 50vh;
  }

  &__panel-inner {
    padding: 20px 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__panel-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 8px 12px;
  }

  &__panel-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 8px;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);

      .player__panel-item-name {
        color: #ffffff;
      }

      .player__panel-item-play {
        opacity: 1;
      }
    }
  }

  &__panel-item-img-wrap {
    position: relative;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 2px;
    overflow: hidden;
  }

  &__panel-item-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    background-color: #b05048;
  }

  &__panel-item-play {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.15s;
  }

  &__panel-item-play-icon {
    color: #ffffff;
    font-size: 12px;
    margin-left: 1px;
  }

  &__panel-item-name {
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    font-weight: 500;
    transition: color 0.15s;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__panel-header {
    text-align: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__panel-song-name {
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  &__panel-song-singer {
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
  }

  &__lyrics-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    flex: 1;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 3px;
    }
  }

  &__lyrics-line {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }

  &__lyrics-empty {
    color: rgba(255, 255, 255, 0.4);
    font-size: 14px;
    text-align: center;
    padding: 20px;
  }

  &__body {
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    height: 90px;
    position: relative;
    z-index: 5;
    gap: 0;
  }

  &__left {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__center {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 24px;
  }

  &__right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__toggle {
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.15s;
    flex-shrink: 0;
    margin-right: 10px;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.12);
    }
  }

  &__toggle-icon {
    width: 20px;
    height: 20px;
  }

  &__channel-cover {
    width: 52px;
    height: 52px;
    flex-shrink: 0;
    margin-right: 12px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      background-color: #b05048;
    }
  }

  &__channel-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    min-width: 110px;
    flex-shrink: 0;
    margin-right: 10px;
  }

  &__channel-label {
    font-size: 10px;
    color: #f37021;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    line-height: 1;
  }

  &__channel-name {
    font-size: 15px;
    color: #ffffff;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon-btn {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.15s;
    flex-shrink: 0;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.12);
    }
  }

  &__icon {
    width: 18px;
    height: 18px;

    &--heart {
      stroke-width: 2;
    }

    &--skip {
      width: 20px;
      height: 20px;
    }
  }

  &__icon-btn--favorited {
    color: #ff4d4f;
    background-color: rgba(255, 77, 79, 0.15);
    border-color: #ff4d4f;

    svg {
      fill: #ff4d4f !important;
      stroke: #ff4d4f !important;
    }
  }

  &__play-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: #f37021;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s, transform 0.1s;
    flex-shrink: 0;
    margin-right: 18px;

    &:hover {
      background-color: #d95e12;
    }

    &:active {
      transform: scale(0.96);
    }
  }

  &__play-icon {
    width: 18px;
    height: 18px;
    margin-left: 2px;
  }

  &__track {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    min-width: 0;
  }

  &__track-title {
    font-size: 13px;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    text-align: left;
  }

  &__track-lyrics {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    min-height: 18px;
  }

  &__track-progress {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  &__progress-bar {
    flex: 1;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    cursor: pointer;
    position: relative;
  }

  &__progress-filled {
    height: 100%;
    background-color: #f37021;
    border-radius: 2px;
  }

  // VIP歌曲30秒限制节点
  &__progress-vip-marker {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    background-color: #ff4d4f;
    border-radius: 50%;
    z-index: 2;
    box-shadow: 0 0 4px rgba(255, 77, 79, 0.6);
  }

  &__progress-thumb {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: #ffffff;
    border-radius: 50%;
    cursor: grab;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 1;
  }

  &__progress-bar:hover &__progress-thumb,
  &__progress-bar:active &__progress-thumb {
    opacity: 1;
  }

  &__time {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
    flex-shrink: 0;
    font-weight: 400;
    white-space: nowrap;
    min-width: 85px;
    text-align: right;
  }

  &__volume-bar {
    width: 70px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    cursor: pointer;
    margin: 0 6px;
    position: relative;
  }

  &__volume-filled {
    height: 100%;
    background-color: rgba(255, 255, 255, 0.65);
    border-radius: 2px;
  }

  &__volume-thumb {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: #ffffff;
    border-radius: 50%;
    cursor: grab;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 1;
  }

  &__volume-bar:hover &__volume-thumb,
  &__volume-bar:active &__volume-thumb {
    opacity: 1;
  }
}

.auth-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(154, 31, 19, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;

  &__inner {
    position: relative;
    width: 100%;
    max-width: 420px;
    background: linear-gradient(to bottom, #b02518 0%, #8a1a12 100%);
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    padding: 40px 30px 30px;
    box-sizing: border-box;
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__close-icon {
    width: 20px;
    height: 20px;
  }

  &__content {
    width: 100%;
  }

  &__logo {
    text-align: center;
    margin-bottom: 15px;
  }

  &__logo-img {
    height: 50px;
    width: auto;
    object-fit: contain;
  }

  &__title {
    font-size: 28px;
    font-weight: 300;
    color: #ffffff;
    text-align: center;
    margin: 0 0 8px 0;
  }

  &__subtitle {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    margin: 0 0 25px 0;
  }

  &__social-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }

  &__social-btn {
    width: 100%;
    height: 42px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.2s;
    color: #ffffff;

    &--facebook {
      background-color: #3b5998;

      &:hover {
        background-color: #2d4373;
      }
    }

    &--google {
      background-color: #ffffff;
      color: #555555;

      &:hover {
        background-color: #f5f5f5;
      }
    }

    &--apple {
      background-color: #000000;

      &:hover {
        background-color: #333333;
      }
    }

    &--wechat {
      background-color: #07c160;

      &:hover {
        background-color: #06ad56;
      }
    }

    &--phone {
      background-color: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.3);

      &:hover {
        background-color: rgba(255, 255, 255, 0.25);
      }
    }
  }

  &__social-icon {
    width: 20px;
    height: 20px;
  }

  &__divider {
    display: flex;
    align-items: center;
    margin: 20px 0;
    gap: 15px;
  }

  &__divider-line {
    flex: 1;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
  }

  &__divider-text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    text-transform: lowercase;
  }

  &__form {
    width: 100%;
  }

  &__form-group {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;

    &--checkbox {
      margin-bottom: 20px;
      display: block;
    }
  }

  &__input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: none;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.25);
    color: #ffffff;
    font-size: 14px;
    box-sizing: border-box;
    outline: none;
    transition: all 0.2s;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
      background-color: rgba(0, 0, 0, 0.35);
    }
  }

  &__required {
    color: #f37021;
    font-size: 14px;
    flex-shrink: 0;
    line-height: 1;
  }

  &__link {
    color: #f37021;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  &__checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    user-select: none;

    input[type="checkbox"] {
      display: none;

      &:checked + .auth-modal__checkbox-custom {
        background-color: #f37021;
        border-color: #f37021;

        &::after {
          display: block;
        }
      }
    }
  }

  &__checkbox-custom {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    position: relative;
    transition: all 0.2s;

    &::after {
      content: '';
      display: none;
      position: absolute;
      left: 3px;
      top: 0px;
      width: 5px;
      height: 9px;
      border: solid #ffffff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }

  &__submit-btn {
    width: 100%;
    height: 44px;
    border: none;
    border-radius: 4px;
    background-color: #f37021;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: #d95e12;
    }
  }

  &__footer {
    margin-top: 20px;
    text-align: center;
  }

  &__footer-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0 0 8px 0;
  }

  &__footer-link {
    color: #f37021;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }

    &--small {
      font-size: 12px;
    }
  }
}

.vip-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;

  &__inner {
    background: linear-gradient(135deg, #5c3538 0%, #4a282b 100%);
    border-radius: 12px;
    padding: 30px 40px;
    text-align: center;
    min-width: 320px;
    animation: scaleIn 0.2s ease-out;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 15px;
    background-color: rgba(243, 112, 33, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 8px 0;
  }

  &__desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 25px 0;
    line-height: 1.5;
  }

  &__btn-group {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  &__btn {
    padding: 10px 24px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    text-decoration: none;
    display: inline-block;

    &--cancel {
      background-color: transparent;
      color: rgba(255, 255, 255, 0.7);
      border: 1px solid rgba(255, 255, 255, 0.3);

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    &--vip {
      background-color: #f37021;
      color: #ffffff;

      &:hover {
        background-color: #d95e12;
      }
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.site-footer {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding-bottom: 0;

  &__top {
    background-color: #7a1710;
    padding: 25px 40px;
  }

  &__top-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }

  &__top-text {
    color: rgba(255, 255, 255, 0.85);
  }

  &__top-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: #ffffff;
  }

  &__top-desc {
    font-size: 13px;
    margin: 0;
    opacity: 0.8;
  }

  &__top-logos {
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
  }

  &__logo {
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    font-weight: bold;
    font-style: italic;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }

    &--main {
      font-size: 20px;
      color: #ffffff;
    }
  }

  &__bottom {
    background-color: #8a1a12;
    padding: 30px 40px;
  }

  &__bottom-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 30px;
  }

  &__bottom-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__social {
    display: flex;
    gap: 15px;
  }

  &__social-link {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    transition: all 0.2s;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.6);
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;

    a {
      color: rgba(255, 255, 255, 0.75);
      text-decoration: none;
      font-size: 16px;
      transition: color 0.2s;

      &:hover {
        color: #ffffff;
      }
    }
  }

  &__bottom-right {
    text-align: right;
  }

  &__info {
    color: rgba(255, 255, 255, 0.75);
    font-size: 12px;
    line-height: 1.8;

    p {
      margin: 0;
    }
  }

  &__company {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px !important;
  }

  &__contact {
    display: flex;
    gap: 20px;
    justify-content: flex-end;
    margin-bottom: 4px !important;
  }

  &__address {
    margin-bottom: 8px !important;
  }

  &__copyright {
    margin-bottom: 4px !important;
  }

  &__icp {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    &__top {
      padding: 20px;
    }

    &__top-inner {
      flex-direction: column;
      text-align: center;
    }

    &__top-logos {
      justify-content: center;
      gap: 15px;
    }

    &__bottom {
      padding: 25px 20px;
    }

    &__bottom-inner {
      flex-direction: column;
      text-align: center;
    }

    &__bottom-left {
      align-items: center;
    }

    &__bottom-right {
      text-align: center;
    }

    &__contact {
      justify-content: center;
      flex-direction: column;
      gap: 4px;
    }

    &__links {
      justify-content: center;
    }
  }
}
</style>
